import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Button } from '@metarouter-private/mr-mui';

export default function AuditLogPager({ onPrev, onNext, hasPrevPage, hasNextPage }) {
  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end">
      <Button data-test-id="auditLogPrevPage" onClick={onPrev} disabled={!hasPrevPage}>
        Previous
      </Button>
      <Button data-test-id="auditLogNextPage" onClick={onNext} disabled={!hasNextPage}>
        Next
      </Button>
    </Stack>
  );
}

AuditLogPager.propTypes = {
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  hasPrevPage: PropTypes.bool.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
};
